import $ from 'gridstrap/lib/gs-zepto';

export class GSScreenshotCarouselImage {

	//
	// Properties
	//

	root;
	carousel;
	image;
	imageWidth;
	imageHeight;
	prevItem;
	nextItem;

	get isLoaded() { return this.root.hasClass('is-loaded'); }
	get offset()   { return this.root.offset().left; }
	get width()    { return this.root.width(); }

	set isLoaded(value) { this.root.toggleClass('is-loaded', !!value); }
	set isActive(value) { this.root.toggleClass('is-active', !!value); }

	//
	// Methods
	//

	select() {
		if (this.carousel.activeItem) {
			this.carousel.activeItem.root.find(':focus').blur();
			this.carousel.activeItem.isActive = false;
		}

		this.isActive = true;
		this.carousel.activeItem = this;
		if (this.isLoaded) this.carousel.align();

		const { prevButton, nextButton } = this.carousel;
		prevButton.toggleClass('is-disabled', !this.prevItem);
		nextButton.toggleClass('is-disabled', !this.nextItem);
	}

	calibrateSize() {
		let { viewportWidth, viewportHeight } = this.carousel;
		let { widthClearance, heightClearance } = this.carousel;
		let { imageWidth: width, imageHeight: height } = this;
		let ratio = width / height;

		if (height > viewportHeight - heightClearance) {
			height = viewportHeight - heightClearance;
			width = Math.floor(height * ratio);
		}

		if (width > viewportWidth - widthClearance) {
			width = viewportWidth - widthClearance;
			height = Math.floor(width / ratio);
		}

		this.image.attr({ width, height });
		this.carousel.align();
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.image = this.root.find('.gs-ScreenshotCarousel-image');
	}

	gsOnInit() {
		this.carousel = this.root.closest('.gs-ScreenshotCarousel').gs(0);
		this.prevItem = this.root.prev().gs(0);
		this.nextItem = this.root.next().gs(0);

		this.root.on('click', () => this.select());
		this.image.one('load', () => this.handleImageLoad());
	}

	gsOnDestroy() {
		this.root.off();
	}

	gsOnWindowResize() {
		if (!this.isLoaded) return;
		this.calibrateSize();
	}

	handleImageLoad() {
		let { naturalWidth, naturalHeight } = this.image.get(0);
		this.imageWidth = naturalWidth;
		this.imageHeight = naturalHeight;
		this.isLoaded = true;
		this.calibrateSize();
	}

}
